import { message } from 'antd';
import React, { useState, useContext } from 'react';
import { changeUseAppointmentDesk } from 'api/ListingController';
import errorReporter from '@app/errorReporter';
import { SUPPORT_EMAIL } from 'utils';
import Switch from '../Switch';
import ManageListingsContext from '../../Router/pages/AppointmentDeskPage/ManageListings/ManageListingsContext';

const UseAppointmentDeskToggle: React.FC<{
  listingId: string;
  useAppointmentDesk: boolean;
  address: string;
}> = ({ listingId, useAppointmentDesk, address }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setIsChecked] = useState(useAppointmentDesk);
  const { setEnabledListingsCount } = useContext(ManageListingsContext);

  const handleToggleChange = async (newChecked: boolean) => {
    try {
      setIsLoading(true);
      await changeUseAppointmentDesk(listingId, newChecked);
      message.success(
        <span data-cy="listing-enable-success">
          Answering service {newChecked ? 'enabled' : 'disabled'} for {address}
        </span>,
      );
      setIsChecked(newChecked);
      setEnabledListingsCount(prev => prev + (newChecked ? 1 : -1));
    } catch (err) {
      errorReporter.error('Error toggle useAppointmentDesk', err);
      message.error(
        <span data-cy="listing-enable-error">
          {`Answering service couldn’t be ${
            newChecked ? 'enabled' : 'disabled'
          } for ${address.trim()}. If this issue persists, contact `}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </span>,
      );
      setIsChecked(!newChecked);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Switch
      checked={checked}
      onChange={handleToggleChange}
      loading={isLoading}
      data-cy={`listing-enable-${listingId}`}
    />
  );
};

export default UseAppointmentDeskToggle;
